import { useCallback } from 'react'
import {  getBids } from '../../sushi/utils'
import { getBids as getBids2 } from '../../sushi/exchangeNFTs'
import useYam from "../bakery/useYam"
import { BigNumber } from 'bignumber.js'
import { BIGNUMBER_FMT } from '../../constants/bakery'
import { compare } from '../../utils/func'
import { userBidNFTContract } from '../../userType/userBidNFTContract'
import { MARKETTYPE, MARKETMULTITOKEN, MARKETTYPEV1, MARKETTYPEV3 } from '../../constants/bakery/nft'
import { userNftAddress } from '../../userType/userNftAddress'
import { userTokenAddress } from '../../userType/userTokenAddress'
import { multiTokenExchangeNftContract } from '../../userType/multiTokenExchangeNftContract'
import { userTokenDecimals } from '../../userType/userTokenDecimals'
import { userExchangeNFTContract } from '../../userType/userExchangeNFTContract'
import { userV3NFTContract } from '../../userType/userV3NFTContract'

const useBidList = (tokenId?: string, nftType?: string, tokenName?: string) => {

  const sushi = useYam()
  let decimals = userTokenDecimals(tokenName)
  let exchangeNFTContract: any
  let isMultiTokenNft = false
  if(nftType && MARKETTYPE.hasOwnProperty(nftType)){
    exchangeNFTContract = userBidNFTContract(sushi, nftType)
  }else if(nftType && MARKETMULTITOKEN.hasOwnProperty(nftType)){
    exchangeNFTContract = multiTokenExchangeNftContract(sushi, nftType)
    isMultiTokenNft = true
  }else if(nftType && MARKETTYPEV1.hasOwnProperty(nftType)){
    exchangeNFTContract = userExchangeNFTContract(sushi, nftType)
  }else if(nftType && MARKETTYPEV3.hasOwnProperty(nftType)){
    exchangeNFTContract = userV3NFTContract(sushi, nftType)
    isMultiTokenNft = true
  }

  const getList = useCallback(async () => {
    try {
      let bids
      if(!isMultiTokenNft){
        bids = await getBids(exchangeNFTContract, tokenId)
      }else{
        let nftAddress = userNftAddress(sushi, nftType)
        let quoteAddress = userTokenAddress(sushi, tokenName)
        bids = await getBids2(exchangeNFTContract,nftAddress, quoteAddress, tokenId)
  }
      const list = bids.map((item: any) => {
        return {
          bidder: item.bidder,
          price: new BigNumber(item.price).div(new BigNumber(10).pow(decimals)).integerValue(BigNumber.ROUND_CEIL).toFormat(0, BIGNUMBER_FMT),
          curPrice: new BigNumber(item.price).div(new BigNumber(10).pow(decimals))
        }
      })
      return list.sort(compare('curPrice', 'des'))
    } catch (e) {
      return false
    }
  }, [exchangeNFTContract, tokenId, decimals,isMultiTokenNft,nftType,sushi,tokenName])

  return getList
}

export default useBidList